import React from 'react';

import PersonIcon from '@mui/icons-material/Person';
import { IconButton, Stack, Typography } from '@mui/material';

import CopyableField from '~/components/Common/CopyableField';
import UserName from '~/components/Common/UserName';

type PromoCodeUser = {
  userId: string;
  userIdFor?: string;
  onUserIconClick?: () => void;
};

function PromoCodeUser({ userId, userIdFor, onUserIconClick }: PromoCodeUser) {
  return (
    <Stack
      direction="column"
      sx={{
        minHeight: '40px',
        justifyContent: 'center',
      }}
    >
      <CopyableField value={userId} label={<UserName asLink userId={userId} />}>
        {onUserIconClick && (
          <IconButton onClick={onUserIconClick} size="small">
            <PersonIcon />
          </IconButton>
        )}
      </CopyableField>

      {userIdFor && userId !== userIdFor && (
        <>
          <Typography component="span">(used on behalf of:</Typography>
          <Typography component="span">
            <CopyableField value={userIdFor} label={<UserName asLink userId={userIdFor} />} />)
          </Typography>
        </>
      )}
    </Stack>
  );
}

export default PromoCodeUser;
